import * as React from "react";
const NewsPerson = (props) => (
  <svg
    width={20}
    height={27}
    viewBox="0 0 20 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 0C6.61503 0 3.87097 2.74406 3.87097 6.12903C3.87097 9.514 6.61503 12.2581 10 12.2581C13.385 12.2581 16.129 9.514 16.129 6.12903C16.129 2.74406 13.385 0 10 0ZM5.80645 6.12903C5.80645 3.813 7.68397 1.93548 10 1.93548C12.316 1.93548 14.1935 3.813 14.1935 6.12903C14.1935 8.44507 12.316 10.3226 10 10.3226C7.68397 10.3226 5.80645 8.44507 5.80645 6.12903Z"
      fill={props.color}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.12903 14.1935C2.74406 14.1935 0 16.9376 0 20.3226C0 23.7076 2.74406 26.4516 6.12903 26.4516H13.871C17.2559 26.4516 20 23.7076 20 20.3226C20 16.9376 17.2559 14.1935 13.871 14.1935H6.12903ZM1.93548 20.3226C1.93548 18.0065 3.813 16.129 6.12903 16.129H13.871C16.187 16.129 18.0645 18.0065 18.0645 20.3226C18.0645 22.6386 16.187 24.5161 13.871 24.5161H6.12903C3.813 24.5161 1.93548 22.6386 1.93548 20.3226Z"
      fill={props.color}
    />
  </svg>
);
export default NewsPerson;
